import React, { useState } from "react";
import styles from "./CreationProfileImage.module.scss";
import { useDispatch } from "react-redux";
import {
  resetProfileURL,
  uploadProfileImage,
} from "../../../reducer/profileSlice";
import NoImageSVG from "../../SVGComponents/NoImageSVG";
import { serverFiles, compressImage } from "utils/utils";
import toast from "components/Toast/toast";
import ProfilePicRemoveModal from "components/Modal/ProfilePicRemoveModal";

const CreationProfileImage = ({
  handleImageClick,
  fileInputRef,
  profileURL,
}) => {
  const dispatch = useDispatch();
  const [showPopupModal, setShowPopupModal] = useState(false);

  const handleRemoveImage = async () => {
    // e.stopPropagation();
    // setShowPopupModal(true);
    dispatch(resetProfileURL());
    dispatch(uploadProfileImage({ payload: null, type: "CREATOR" }));
    if (fileInputRef.current) {
      fileInputRef.current.value = null;
    }
    setShowPopupModal(false);
  };

  const handleImageChange = async (e) => {
    const file = e.target.files[0];

    if (file) {
      const validTypes = ["image/jpeg", "image/png"];

      if (!validTypes.includes(file.type)) {
        toast.error("Only JPG and PNG files are allowed");
        return;
      }

      if (file.size > 5242880) {
        toast.error("File size exceeded 5MB");
        return;
      }

      let fileToUpload = file;
      if (file.type.startsWith("image/")) {
        fileToUpload = await compressImage(file);
      }

      const formData = new FormData();
      formData.append("file", fileToUpload);

      await dispatch(
        uploadProfileImage({ payload: formData, type: "CREATOR" })
      );
    } else {
      // reset profile URL
      profileURL = null;
    }
  };

  // console.log(profileURL)

  // useEffect(() => {
  //   dispatch(getProfileImage());
  // }, []);

  return (
    <div className={styles.profile_form_photo}>
      {profileURL ? (
        <div className={styles.profile_image_success}>
          <img
            height={100}
            width={100}
            style={{ borderRadius: "100%", border: "2px solid #C8CDF3" }}
            src={profileURL ? `${serverFiles(profileURL)}` : null}
            alt="Profile Preview"
          />
          <button
            type="button"
            className={styles.reset_photo_btn}
            onClick={(e) => {
              e.stopPropagation();
              setShowPopupModal(true);
            }}
          >
            ✕
          </button>
          <ProfilePicRemoveModal
            showPopupModal={showPopupModal}
            setShowPopupModal={setShowPopupModal}
            handleRemoveImage={handleRemoveImage}
          />
        </div>
      ) : (
        <div
          className={styles.profile_photo_placeholder}
          onClick={handleImageClick}
        >
          <NoImageSVG type="profile" height={90} width={90} />
          <input
            type="file"
            accept="image/*"
            ref={fileInputRef}
            onChange={handleImageChange}
            style={{ display: "none" }}
          />
        </div>
      )}

      <div className={styles.profile_photo_right}>
        <p className={styles.profile_photo_description}>
          Only .jpg or .png allowed
        </p>
        <button
          type="button"
          className={styles.profile_photo_button}
          onClick={(e) => {
            e.stopPropagation();
            handleImageClick();
          }}
        >
          Upload Photo
        </button>
      </div>
    </div>
  );
};

export default CreationProfileImage;
